<template>
  <div class="relative">
    <button v-if="areaLevel === 'district' || areaLevel === 'zone'" class="mb-2 lg:mb-0 bg-white hover:bg-grey-lightest text-black text-xs font-bold py-2 px-3 rounded flex items-center mr-2" @mouseover="isShowLayerSelection = true">
      <v-icon scale="1.2" class="self-center text-button-icon" name="layer-group" />
    </button>
    <div class="mb-2 lg:mb-0 bg-white py-2 px-3 w-40 rounded border absolute pin-b pin-l flex flex-col z-1010" v-if="isShowLayerSelection" @mouseleave="isShowLayerSelection = false">
      <label class="text-black font-bold flex items-center">
        <input class="mr-1" type="checkbox" :checked="isShowDistrict" @click="showDistrictsLayer">
        <span class="text-sm">
          Kota/Kabupaten
        </span>
      </label>
      <label class="text-black font-bold flex items-center">
        <input class="mr-1" type="checkbox" :checked="isShowZone" @click="showZoneLayer">
        <span class="text-sm">
          Zona
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'area-filter',
  props: {
    areaLevel: String,
    isShowDistrict: Boolean,
    isShowZone: Boolean,
    showDistrictsLayer: Function,
    showZoneLayer: Function
  },
  data () {
    return {
      isShowLayerSelection: false
    }
  }
}
</script>
